import { useSelector } from 'react-redux'

import { customDomainSelector } from 'selectors/custom_domain'
import { emailSelector } from 'selectors/invitee'

export const useInviteeSignUp = () => {
  const inviteeEmail = useSelector(emailSelector)
  const encodedEmail = encodeURIComponent(inviteeEmail)

  const { default_domain: defaultDomain } = useSelector(customDomainSelector)

  return {
    encodedEmail,
    signUpByEmailPath: `${defaultDomain}/app/signup?email=${encodedEmail}&section=booking`,
  }
}
